import { useEffect } from 'react';
import { setActiveTab } from '../store/uiModalStore';
import { useExtensionStore } from '../extensions/store';
import { clearRequestDraft, useRequestDraftStore } from '../store/requestDraftOpen';

/**
 * Opens a draft from store/requestDraftOpen as a new unsaved request tab in
 * the API Client and shows it. Mounted once, in App. While the API Client is
 * switched off (Settings → Extensions) nothing opens — callers hide the
 * action then, and a draft that slips through is dropped.
 */
export function useRequestDraftOpen({ createNewRequestTab }) {
  const draft = useRequestDraftStore((s) => s.draft);

  useEffect(() => {
    if (!draft) return;
    clearRequestDraft();
    if (useExtensionStore.getState().apiClientEnabled === false) return;
    createNewRequestTab({ method: draft.method, url: draft.url, name: draft.name || null });
    setActiveTab('collections');
  }, [draft, createNewRequestTab]);
}
